import request from '@/util/request'

/** 
 * 根据名称获取链接
 * const data = {
 *  name: ""
 * }
 */
export function getLinkByName(data) {
    return request({
        url: '/links',
        method: 'get',
        params: data
    })
}